require('./bootstrap');
// import Swiper JS
import Swiper from 'swiper';
import swal from 'sweetalert2';
window.Swal = swal;
// import Swiper styles
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
import moment0 from "moment";

const WOW = require('wowjs');
window.wow = new WOW.WOW({
    offset: 200,          // default
});
window.wow.init();

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination]);
window.Swiper = Swiper;


window.toastr = require('toastr/toastr');
require("jquery-validation/dist/jquery.validate.min");
require("jquery-validation/dist/localization/messages_fr");

window.Cookies = require('js-cookie');
require('jquery.scrollbar');
require('jquery-scroll-lock');
require('./argon');
//
// require('./livewire-sortable')

// // require('./sidebar');
require('./scrollToTop');
//
jQuery.validator.setDefaults({
    errorElement: 'span',
    errorPlacement: function (error, element) {
        error.addClass('invalid-feedback');
        element.closest('.form-group').append(error);
    },
    highlight: function (element, errorClass, validClass) {
        $(element).addClass('is-invalid');
    },
    unhighlight: function (element, errorClass, validClass) {
        $(element).removeClass('is-invalid');
    }
});
//
$('.form-validate').each(function() {   // <- selects every <form> on page
    $(this).validate({
        submitHandler: function (form) {
            form.submit();
        }
    });
});
//
$(document).ready(function () {
    window.livewire.on('toastr', param => {
        window.toastr[param['type']](param['message'],param['title'])
    });
})
require('select2');
$('.select2').select2();
///
// window.onscroll = function() {scrollFunction()};
//
// function scrollFunction() {
//     if (document.getElementById("nav2")){
//         if (document.body.scrollTop > 400 || document.documentElement.scrollTop > 400) {
//             document.getElementById("nav2").style.top = "0";
//         } else {
//             document.getElementById("nav2").style.top = "-80px";
//         }
//     }
// }
//
// $(document).click(function (event) {
//     var clickover = $(event.target);
//     var _opened = $("#nav").hasClass("collapse show");
//     var _opened2 = $("#nav2").hasClass("collapse show");
//
//     if (_opened === true && !clickover.hasClass("navbar-toggler")) {
//         $("button.navbar-toggler").click();
//     }
//     if (_opened2 === true && !clickover.hasClass("navbar-toggler")) {
//         $("button.navbar-toggler").click();
//     }
// });
// import Swiper from 'swiper';
// import 'swiper/swiper-bundle.css';
// var swiper_testimonials =new Swiper('.swiper-container', {
//     slidesPerView: 'auto',
//     centeredSlides: false,
//     loop: false,
//     slidesPerGroup: 1,
//     paginationClickable: true,
//     pagination: {
//         el: '.swiper-pagination',
//         clickable: true,
//     },
// });



$("#show_hide_password a").on('click', function(event) {
    event.preventDefault();
    if($('#show_hide_password input').attr("type") == "text"){
        $('#show_hide_password input').attr('type', 'password');
        $('#show_hide_password i').addClass( "fa-eye-slash" );
        $('#show_hide_password i').removeClass( "fa-eye" );
    }else if($('#show_hide_password input').attr("type") == "password"){
        $('#show_hide_password input').attr('type', 'text');
        $('#show_hide_password i').removeClass( "fa-eye-slash" );
        $('#show_hide_password i').addClass( "fa-eye" );
    }
});


window.moment = moment0;
require("tempusdominus-bootstrap-4");


$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
    icons: {
        time: 'far fa-clock',
        date: 'far fa-calendar',
        up: 'far fa-arrow-up',
        down: 'far fa-arrow-down',
        previous: 'far fa-chevron-left',
        next: 'far fa-chevron-right',
        today: 'far fa-calendar-check-o',
        clear: 'far fa-trash',
        close: 'far fa-times'
    }
});

$('button[data-confirm]').on('click',function () {
    Swal.fire({
        title: 'Etes vous sûr(e) ?',
        text: $(this).data('confirm-text'),
        showDenyButton: true,
        confirmButtonText: `Oui`,
        denyButtonText: `Non`,
    }).then((result) => {
        if (result.value) {
            $('#'+$(this).data('confirm')).submit();
        }
    })
});

import bsCustomFileInput from 'bs-custom-file-input'
$(document).ready(function () {
    bsCustomFileInput.init()
})


// Select all links with hashes
$('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
            &&
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };
                });
            }
        }
    });

import {confetti} from 'dom-confetti';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
if (urlParams.has('confetti')){
    window.addEventListener('DOMContentLoaded', (event) => {
        confetti_launch();
    });
}
const confetti_button = document.querySelector("#confetti-button");
if (confetti_button){
    confetti_button.addEventListener("click",confetti_launch)
}
function confetti_launch(){
    const button1 = document.querySelector(".confetti1");
    const button2 = document.querySelector(".confetti2");
    const button3 = document.querySelector(".confetti3");
    confetti(button1,{elementCount:20});
    confetti(button2,{elementCount:20});
    confetti(button3,{elementCount:20});
}
